import { Injectable } from '@angular/core';

export type AuthLogEntry = {
  event: string;
  data: unknown;
  timestamp: string;
};

@Injectable({ providedIn: 'root' })
export class AuthLoggerService {
  private readonly KEY = 'auth.logs';

  constructor() {
    if (typeof window !== 'undefined') {
      (window as unknown as { getAuthLogs: () => AuthLogEntry[] }).getAuthLogs = () => this.getLogs();
    }
  }

  log(event: string, data?: unknown): void {
    try {
      const logs = this.getLogs();
      logs.push({
        event,
        data: data ?? null,
        timestamp: new Date().toISOString()
      });
      localStorage.setItem(this.KEY, JSON.stringify(logs));
    } catch {
      // Quota, private mode, or serialization — avoid breaking auth flow
    }
  }

  getLogs(): AuthLogEntry[] {
    try {
      const raw = localStorage.getItem(this.KEY);
      if (!raw) return [];
      const parsed = JSON.parse(raw) as unknown;
      return Array.isArray(parsed) ? (parsed as AuthLogEntry[]) : [];
    } catch {
      return [];
    }
  }

  clearLogs(): void {
    try {
      localStorage.removeItem(this.KEY);
    } catch {
      /* ignore */
    }
  }

  downloadLogs(): void {
    const logs = this.getLogs();
    const blob = new Blob([JSON.stringify(logs, null, 2)], { type: 'application/json' });
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = 'auth-logs.json';
    a.click();
    window.URL.revokeObjectURL(url);
  }
}
